import React from 'react';
import PropTypes from 'prop-types';
import '../academicons/css/academicons.min.css';
import '../icomoon/style.css';

// Bluesky is in neither icon font, and the Font Awesome class used before
// only rendered where a theme happened to load Font Awesome.
const BlueskyIcon = () => (
  <svg
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M12 10.8c-1.087-2.114-4.046-6.053-6.798-7.995C2.566.944 1.561 1.266.902 1.565.139 1.908 0 3.08 0 3.768c0 .69.378 5.65.624 6.479.815 2.736 3.713 3.66 6.383 3.364-3.912.58-7.387 2.005-2.83 7.078 5.013 5.19 6.87-1.113 7.823-4.308.953 3.195 2.05 9.271 7.733 4.308 4.267-4.308 1.172-6.498-2.74-7.078 2.67.297 5.568-.628 6.383-3.364.246-.828.624-5.79.624-6.478 0-.69-.139-1.861-.902-2.206-.659-.298-1.664-.62-4.3 1.24C16.046 4.748 13.087 8.687 12 10.8Z" />
  </svg>
);

/** The profile links of a person, in the order they are shown. */
const LINKS = [
  ['website', 'Website', () => <span className="icon-home" />],
  ['twitter', 'X (formerly Twitter)', () => <span className="icon-twitter" />],
  ['mastodon', 'Mastodon', () => <i className="ai ai-mastodon" />],
  ['bluesky', 'Bluesky', () => <BlueskyIcon />],
  ['linkedin', 'LinkedIn', () => <span className="icon-linkedin" />],
  ['github', 'GitHub', () => <span className="icon-github" />],
  [
    'google_scholar',
    'Google Scholar',
    () => <i className="ai ai-google-scholar" />,
  ],
  ['orcid_id', 'ORCID', () => <i className="ai ai-orcid" />],
  ['researchgate', 'ResearchGate', () => <i className="ai ai-researchgate" />],
];

export const hasSocialLinks = (content) =>
  LINKS.some(([field]) => content[field]);

/** The icon row of a People or Author page. */
const SocialLinks = ({ content }) => (
  <div className="view-section__social-links">
    {LINKS.filter(([field]) => content[field]).map(([field, title, icon]) => (
      <a
        key={field}
        href={content[field]}
        className="view-section__social-link"
        target="_blank"
        rel="noopener noreferrer"
        title={title}
      >
        {icon()}
      </a>
    ))}
  </div>
);

SocialLinks.propTypes = {
  content: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default SocialLinks;
